<template>
    <div class="set-pos">        
        <b-alert :variant="alertvariant" :show="dismissCountDown"
             dismissible             
             @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
            <p>{{alerttxt}}</p>
            <b-progress :variant="alertvariant"
                  :max=5
                  :value="dismissCountDown"
                  height="4px">
            </b-progress>
        </b-alert>
        <b-form  v-on:submit.prevent="onSubmit" @reset="onReset">
            <b-form-group id="SetupCredentials"
                    label="Registrar Caja:"
                    label-for="PosId"> 
            <b-form-input id="PosId"
                      type="text"
                      v-model="form.PosId"
                      required
                      placeholder="Nº de caja...">
            </b-form-input>  
            <b-form-input id="Pwd"
                      type="password"
                      v-model="form.Pwd"
                      required
                      placeholder="Contraseña...">
            </b-form-input>
             </b-form-group>
            <b-button type="submit" variant="primary">Aceptar</b-button>
            <b-button type="reset" variant="danger">Borrar Formulario</b-button>  
        </b-form> 
    </div>
</template>

<script>
var axios = require('axios')
export default {
    name: 'SetPOS',
    data() {
        return {
            form: {
                PosId: '',
                Pwd: '' 
            },
            alertvariant : "warning",            
            alerttxt: "",
            dismissCountDown : 0
        }
    },   
    methods: {
        onSubmit(evt) { 
            axios.post(this.ApiBaseUrl +'possetup/setuppos',
                        JSON.stringify(this.form),
                        {headers: {"Content-Type": "application/json"}})            
            .then((response) => {        
                //this.options = response.data;
                var res = JSON.parse(response.data.body.res)
                //var res = response.data.body;
                switch(res.ret) {
                    case "0":
                        this.alertvariant = "danger"
                        this.alerttxt = "Credenciales no válidas"
                        break;
                    case "1":
                        this.alertvariant = "success"
                        this.alerttxt = "Caja registrada correctamente"
                        localStorage.setItem('posId',response.data.body.posId)
                        localStorage.setItem('reqUserCard',res.reqUserCard)
                        localStorage.setItem('defaultlocation',res.defaultlocation)
                        localStorage.setItem('ticketPrinter',res.ticketPrinter)                        
                        this.$store.commit('setPosId', response.data.body.posId)
                        this.$router.push('pos')  
                        break;
                    case "2":
                        this.alertvariant = "warning"
                        this.alerttxt = "Esta caja ya está registrada";  
                        this.$router.push('pos')                         
                        break;
                }               
                this.dismissCountDown = 5;          
                                   
                               
            })
            
        },
        countDownChanged (dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        onReset (evt) {
            evt.preventDefault();
            /* Reset our form values */
            this.form.PosId = '';
            this.form.Pwd = '';            
            /* Trick to reset/clear native browser form validation state */
            this.show = false;
            this.$nextTick(() => { this.show = true });
    }  
    }
}
</script>